module.exports = __webpack_public_path__ + "static/media/minion.0f7fde36.jpg";